import { Box, Typography } from "@mui/material";

export default function Label({ children, ...props }) {
  return (
    <Box sx={{ mb: "6px", ...props.sx }}>
      <Typography variant="subtitle2">{children}</Typography>
    </Box>
  );
}
